import {Link} from "react-router-dom";

export default function Training() {
  return (
    <div className="training">

      {/* HERO SECTION */}
      <section className="training-hero">
        <h2>Industrial Training Program</h2>
        <p>
          We provide hands-on industrial training for B.Tech, MCA and BCA students.
          Learn modern technologies and build real-world projects under industry mentors.
        </p>
      </section>


      {/* TECHNOLOGIES */}
      <section className="training-tech">

        <h3>Technologies Covered</h3>

        <div className="tech-grid">

          <div className="tech-card">HTML & CSS</div>
          <div className="tech-card">JavaScript</div>
          <div className="tech-card">React.js</div>
          <div className="tech-card">Node.js</div>
          <div className="tech-card">Express.js</div>
          <div className="tech-card">MongoDB</div>

        </div>

      </section>


      {/* COURSE FEATURES */}
      <section className="training-features">

        <h3>Program Highlights</h3>

        <div className="feature-grid">

          <div className="feature-card">
            <h4>Live Projects</h4>
            <p>Work on real industry level MERN stack projects.</p>
          </div>

          <div className="feature-card">
            <h4>Industry Mentors</h4>
            <p>Learn directly from professional developers.</p>
          </div>

          <div className="feature-card">
            <h4>Certification</h4>
            <p>Get industry recognized training certificate.</p>
          </div>

          <div className="feature-card">
            <h4>Placement Guidance</h4>
            <p>Resume preparation and interview guidance.</p>
          </div>

        </div>

      </section>


      {/* COURSE DETAILS */}
      <section className="training-details">

        <h3>Course Details</h3>

        <div className="details-grid">

          <div className="detail-box">
            <h4>Duration</h4>
            <p>6 Weeks / 8 Weeks Industrial Training</p>
          </div>

          <div className="detail-box">
            <h4>Eligibility</h4>
            <p>B.Tech / BCA / MCA Students</p>
          </div>

          <div className="detail-box">
            <h4>Mode</h4>
            <p>Offline / Online Training</p>
          </div>

        </div>

      </section>


      {/* CTA */}
      <section className="training-cta">

        <h3>Start Your Career With Us</h3>

        <p>
          Join our industrial training program and gain practical
          development experience.
        </p>

        <Link className="app-cta-link" to="/contact">Enroll Now</Link>

      </section>

    </div>
  );
}
